import { SaveLaserProfileRequest, LaserProfileFormData } from "@/types/laserProfile";
import { getCompanyId } from '@/utils/getCompanyId'

const mapFormDataToApiProfile = (
	data: LaserProfileFormData
): SaveLaserProfileRequest => {



	const company_id = getCompanyId() || '';


	return {
		id: data.id === "duplicate" ? undefined : data.id,
		name: data.name,
		description: data.description,
		company_id,

		laser_properties: {
			id: data.id === "duplicate" ? undefined : data.laser_properties_id,

			wobble_thickness: Number(data.wobble_thickness),
			wobble_overlap_percentage: Number(data.wobble_overlap_percentage),

			power: Number(data.power),
			jump_speed: Number(data.jump_speed),
			jump_delay: Number(data.jump_delay),

			marking_speed: Number(data.marking_speed),
			mark_delay: Number(data.mark_delay),

			laser_on_delay: Number(data.laser_on_delay),
			laser_off_delay: Number(data.laser_off_delay),
			poly_delay: Number(data.poly_delay),
			pipeline_delay: Number(data.pipeline_delay),

			modulation_frequency: Number(data.modulation_frequency),
			repeat_count: Number(data.repeat_count),
			pulse_waveform: Number(data.pulse_waveform),

			velocity_compensation_mode: data.velocity_compensation_mode?.value,
			velocity_compensation_limit: Number(data.velocity_compensation_limit),
			velocity_compensation_aggressiveness: Number(data.velocity_compensation_aggressiveness),

			max_radial_error: Number(data.max_radial_error),
			break_angle: Number(data.break_angle),

			duty_cycle_one: Number(data.power),
			duty_cycle_two: Number(data.power)
		}
	};
};

export default mapFormDataToApiProfile;